module.exports = __webpack_public_path__ + "media/images/checkmark--green-abda9782787a74a59cb7bda96c7d89f4.svg";